import GenericValuationOverlay from './GenericValuationOverlay';
import getGenericValuationsData from './getGenericValuationsData';
import React from 'react';
import ValuationsTable from '../../ValuationsTable/ValuationsTable';

export default function GenericValuationTable() {
	return (
		<section className="relative mb-20">
			<ValuationsTable
				isGated={true}
				valuations={getGenericValuationsData()}
			/>
			<div className="message-overlay">
				<GenericValuationOverlay />
			</div>
		</section>
	);
}
